<div>
    <p>
        {{rejectionReason}}
    </p>
</div>